import type { FormTourConfig } from './formTour';

const SEND_SINGLE_EMAIL_START_PATH = '/candidates';

export const sendSingleEmailTour = {
  taskId: 'send_single_email',
  storageKey: 'onboarding-send-single-email-tour-step',
  startPath: SEND_SINGLE_EMAIL_START_PATH,
  activePathPrefix: SEND_SINGLE_EMAIL_START_PATH,
  navStepCount: 2,
  overlineLabel: 'Send Single Email Tour',
  steps: [
    {
      title: 'Exit Settings',
      description:
        'You are still in Settings from the previous step. Click Exit settings to return to the main app so you can open Candidates.',
      targetTestIds: ['@settings-exit'],
      disableBack: true,
    },
    {
      title: 'Open Candidates',
      description: 'Click Candidates in the sidebar to open the candidates list.',
      targetTestIds: ['@sidebar-candidates'],
    },
    {
      title: 'Open job statuses',
      description:
        'In the Job And Status column, click the job count chip to see jobs linked to this candidate.',
      targetTestIds: ['@candidates-job-statuses-chip'],
    },
    {
      title: 'Open change status',
      description: 'Click the status badge (or Change status) for a job to open the status form.',
      targetTestIds: ['@candidate-status-trigger'],
      highlightTargetTestIds: ['@candidate-job-status-row'],
      contextTargetTestIds: ['@candidates-jobs-modal'],
      closeTargetTestIdsOnBack: ['@candidate-status-modal', '@candidates-jobs-modal'],
    },
    {
      title: 'Select Status',
      description: 'Choose a status. The tour continues when a status is selected.',
      targetTestIds: ['@candidate-status-options', '@candidate-status-selected'],
      panelPlacement: 'above',
      closeTargetTestIdsOnBack: ['@candidate-status-modal'],
    },
    {
      title: 'Choose Send Email',
      description: 'Click Send Email to compose a single email as part of this status change.',
      targetTestIds: ['@candidate-status-action-single-email'],
      panelPlacement: 'above',
    },
    {
      title: 'Select Sender Account',
      description:
        'Click Select Sender Account, choose an account from the list, and the tour will continue when one is selected.',
      targetTestIds: ['@candidate-single-email-from-select', '@candidate-single-email-from-selected'],
      panelPlacement: 'above',
    },
    {
      title: 'Enter the email subject',
      description: 'Add a subject line for your email.',
      targetTestIds: ['@candidate-single-email-subject'],
      panelPlacement: 'above',
    },
    {
      title: 'Enter the email body',
      description: 'Write your message in the body field.',
      targetTestIds: ['@candidate-single-email-body'],
      panelPlacement: 'above',
    },
    {
      title: 'Send your email',
      description:
        'Add attachments if needed, then click Change Status to apply the status and send your email. The tour completes when the form closes.',
      targetTestIds: ['@candidate-status-save'],
      panelPlacement: 'above',
    },
  ],
  stepActions: {
    0: {
      type: 'wait-for-target',
      advanceTo: 1,
      waitForTargetTestIds: ['@sidebar-candidates'],
      autoAdvanceWhenTargetSatisfied: true,
    },
    1: {
      type: 'wait-for-target',
      advanceTo: 2,
      waitForTargetTestIds: ['@candidates-table'],
    },
    2: {
      type: 'wait-for-target',
      advanceTo: 3,
      waitForTargetTestIds: ['@candidates-jobs-modal'],
    },
    3: {
      type: 'wait-for-target',
      advanceTo: 4,
      waitForTargetTestIds: ['@candidate-status-modal'],
    },
    4: {
      type: 'wait-for-target',
      advanceTo: 5,
      waitForTargetTestIds: ['@candidate-status-selected'],
    },
    5: {
      type: 'wait-for-target',
      advanceTo: 6,
      waitForTargetTestIds: ['@candidate-single-email-from-select'],
    },
    6: {
      type: 'wait-for-target',
      advanceTo: 7,
      waitForTargetTestIds: ['@candidate-single-email-from-selected'],
    },
    7: { type: 'next' },
    8: { type: 'next' },
    9: {
      type: 'complete-when-target-absent',
      waitForAbsentTestIds: ['@candidate-status-modal'],
    },
  },
} as const satisfies FormTourConfig;
